import React from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { toast } from 'react-toastify';
import PageTitle from "../common/PageTitle";
import countryCodes from "../constants/countryCodes";
import organizationService from "../../services/organizationService";
import Steper from "../common/steper";

const preparedCodes = countryCodes.map(code => {
    return { value: code.code, label: code.country };
});

export default class Organization extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            name: '',
            countries: preparedCodes,
            selectedCountry: null,
            countryCode: null,
            type: 0,
            error: null
        }
        this.options = {
            autoClose: 3000
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleSubmitOrganization = this.handleSubmitOrganization.bind(this);
    }

    handleChange = event => {
        const { name, value } = event.target;
        this.setState({
            [name]: value,
            error: null
        });
    }

    handleSubmitOrganization(event) {
        event.preventDefault();
        if (this.validateForm()) {
            let organization = {
                name: this.state.name,
                type: this.state.type,
                countryCode: this.state.countryCode
            }
            organizationService.add(organization)
                .then(response => {
                    toast.success("Organization is successfully created!", this.options);
                    this.props.history.push("/dashboard/organization/" + response._id);

                }).catch(error => {
                    toast.error(error.response, this.options)
                });
        } else {
            this.setState({ error: "Organization name is required!" })
        }
    }

    handleCountryChange = selected => {
        const countryCode = selected.target.value;
        const selectedCountry = selected.target.options[selected.target.selectedIndex].textContent;

        this.setState({
            countryCode,
            selectedCountry
        });
    };

    validateForm() {
        return this.state.name;
    }

    handleChange = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    render() {
        const { name, error, countries, countryCode } = this.state;

        return (
            <div>

                <Row noGutters className="page-header pt-4">
                    <PageTitle title="Create new organization" subtitle="Manage organizations" className="text-sm-left" />
                    <Col sm="12" md="12" lg="8" xl="6">
                        <p className="m-0 light-grey">
                            Creating an AirTouch® service organization is an essential part of establishing a secluded and secure communication community. By subscribing to any of the AirTouch® premium service plans for the created organization, you can start inviting co-workers, family, and friends to experience a simple to use, feature packed organization communication service.
                    </p>
                    </Col>
                </Row>
                <Steper step={1} active={true} />
                <Row>
                    <Col sm="12" md="12" lg="8" xl="6">
                        <Card className="mb-4 card-custom" >
                            <CardHeader className="border-bottom card-header-custom">
                                <h6 className="">Create new organization</h6>
                            </CardHeader>
                            <CardBody >

                                <form className="form-wrapper" >
                                    <div className="margin-top-10">
                                        <label className="text-white" htmlFor="">Select country:</label>
                                        <select
                                            value={countryCode || ""}
                                            onChange={this.handleCountryChange}
                                            className="form-control bordered my-2"
                                        >
                                            {countries.map(code => <option key={code.value} value={code.value}>{code.label}</option>)}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="text-white" htmlFor="name">Organization name:</label>
                                        <input
                                            type="text"
                                            className="form-control bordered"
                                            name="name"
                                            id="name"
                                            value={name}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <hr />
                                    {error &&
                                        <div className={'alert alert-danger'}>{error}</div>
                                    }
                                    <div className="clearfix pull-right">
                                        <button className="btn btn-lightblue" onClick={this.handleSubmitOrganization}
                                        > Submit </button>
                                    </div>

                                </form>
                            </CardBody >
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/organizationComponent/organization.js